module.exports = __webpack_public_path__ + "img/aie.acec3394.svg";